// extracted by mini-css-extract-plugin
module.exports = {"productList":"product-list_productList__S1b7b","productListItem":"product-list_productListItem__uA9Id"};